import { Icon } from "@iconify/react";
import React from "react";
import { useLanguage } from "../../../../hooks/use-language";
import { useTranslationsById } from "../../../../hooks/use-translations-by-id";

/**
 * Capa reutilizable para vistas secundarias de un evento.
 *
 * Sirve como base para compartir, horarios y calendarización.
 */
export const EventLayer = ({ children, title, visible, setVisible }) => {
	const lang = useLanguage();
	const texts = useTranslationsById({ mainSectionName: "reading_resources", language: lang });

	return (
		<div
			className={`${
				visible ? "visible" : "hidden"
			} event-layer d-flex flex-column w-100 h-100 p-3`}
		>
			<button
				className="focusable-red d-flex align-items-center onbackground-color font-weight-bold secondary-font"
				onClick={() => setVisible && setVisible(false)}
				aria-label={texts.getText({
					id: "makemake_en_vivo.evento.layer.back_button.aria",
					defaultText: "Go back",
				})}
			>
				<Icon icon="akar-icons:arrow-left" className="pr-2" width={30} /> {title || "N/A"}
			</button>
			<div className="p-3 px-4  d-flex w-100 flex-column flex-grow-1">{children}</div>
		</div>
	);
};
